import { toast } from 'react-toastify';

export const showErrorToast = (message: string) => {
  toast(message, { type: 'error', hideProgressBar: true });
};
